import api from './axios';

/**
 * Phase B — single thread view-summary endpoint.
 * Returns peer info (DM), media, files, links, and per-thread mute flag.
 */
export const getThreadViewRequest = (threadId) =>
  api.get(`/chat/threads/${threadId}/view`);
